import React, { Component } from "react";
import { Link } from "react-router-dom";

// LIBS
import API from "../../../api";
import {
  fioLitleTruncateFromObject,
  getFilialNameFromObject,
  getObjectIdFromField
  // getTypeHistory,
  // getTypeHistoryStyle
} from "../../../lib/helpers/strings";
import { getTimeFormat } from "../../../lib/helpers/dates";
// import {
//   getRoleNameFromObject,
//   getRoleStyleFromObject
// } from "../../lib/helpers/users";

// UI
import { Header, Table, LinkOrText } from "../../../ui";

export default class loginList extends Component {
  state = {
    loading: true,
    loginList: {
      list: [],
      meta: {}
    }
  };

  async componentDidMount() {
    const { data, meta } = await API.widgets.getLoginList({ full: true });

    this.setState({
      loading: false,
      loginList: {
        list: data || [],
        meta: meta || {}
      }
    });
  }

  getTableColumns = () => {
    return [
      {
        title: "ФИО",
        suffix: "пользователя",
        render: ({ item }) => {
          return (
            <Link to={`/users/${item.user_id._id}`}>
              {fioLitleTruncateFromObject(item.user_id)}
            </Link>
          );
        }
      },
      {
        title: "Филиал",
        suffix: "назначенный",
        render: ({ item }) => {
          return (
            <LinkOrText
              toBeforeId="/filials/"
              id={getObjectIdFromField(item._field.filial_id)}
            >
              {getFilialNameFromObject(item._field.filial_id)}
            </LinkOrText>
          );
        }
      },
      // {
      //   title: "Роль",
      //   suffix: "пользователя",
      //   render: ({ item }) => {
      //     return (
      //       <span
      //         className={`label size-small label-${getRoleStyleFromObject(
      //           item._field.role_id
      //         )}`}
      //       >
      //         {getRoleNameFromObject(item._field.role_id)}
      //       </span>
      //     );
      //   }
      // },
      {
        title: "Время",
        suffix: "входа",
        render: ({ item }) => {
          return getTimeFormat(item.created_at);
        }
      }
      // {
      //   title: "Куда",
      //   suffix: "входили",
      //   render: ({ item }) => {
      //     return (
      //       <span
      //         className={`label size-small label-${getTypeHistoryStyle(
      //           item._type
      //         )}`}
      //       >
      //         {getTypeHistory(item._type)}
      //       </span>
      //     );
      //   }
      // }
    ];
  };

  render() {
    return (
      <div>
        <Header size={6}>Вход пользователей</Header>

        <Table
          columns={this.getTableColumns()}
          data={this.state.loginList.list || []}
          loading={this.state.loading}
        />
      </div>
    );
  }
}
